module.exports = __webpack_public_path__ + "static/media/fullscreen-icon.38c486a8.svg";